import { render, staticRenderFns } from "./DataExportOutput.vue?vue&type=template&id=8336f418&scoped=true&"
import script from "./DataExportOutput.vue?vue&type=script&lang=ts&"
export * from "./DataExportOutput.vue?vue&type=script&lang=ts&"
import style0 from "./DataExportOutput.vue?vue&type=style&index=0&id=8336f418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8336f418",
  null
  
)

export default component.exports